import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { KiccCardRow } from '@models/easyCard/kicc';
import { getColorByIssuerCode } from '@models/easyCard/kicc/extension';

interface Props {
    card: KiccCardRow;
    isSelected: boolean;
    onSelect: () => void;
}

/** 간편카드 한 장 (카드사 색상·이름·카드사와 끝 번호) */
function EasyCardRow({ card, isSelected, onSelect }: Props) {
    const {
        cardName, issuerCode, issuerName, cardNoSuffix,
    } = card;
    return (
        <Container data-selected={isSelected} onClick={onSelect}>
            <Info spacing={2}>
                <CardIcon backgroundColor={getColorByIssuerCode(issuerCode)}>
                    <IcChip />
                </CardIcon>
                <Texts spacing={1}>
                    <Text fontWeight='medium' color={colors.textPrimary} ellipsis>{cardName}</Text>
                    <Text size='body-long' fontWeight='medium' color={colors.textPrimary}>
                        {issuerName ? `${issuerName} (${cardNoSuffix})` : cardNoSuffix}
                    </Text>
                </Texts>
            </Info>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    column-gap: var(--spacing-2);
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    padding: var(--spacing-4);
    width: 100%;

    &[data-selected="true"] {
        background-color: var(--color-background-base);
        border-color: var(--color-border-accent);
    }
`;

const Info = styled(Row)`
    flex: 1;
    min-width: 0;
`;

const CardIcon = styled.div<{
    backgroundColor: string;
}>`
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: var(--radius-xs);
    display: flex;
    flex-shrink: 0;
    height: 40px;
    position: relative;
    width: 60px;
`;

const IcChip = styled.div`
    background-color: #FFF2C0;
    border-radius: var(--radius-xs);
    height: 10px;
    left: 7px;
    position: absolute;
    width: 16px;
`;

const Texts = styled(Column)`
    min-width: 0;
`;

export default EasyCardRow;
